<template>
    <section id="content" class="gray-area">
        <div class="container">
            <!-- >>> BreadCrumbs - Row -->
            <div class="row">
                <sdr-breadcrumbs module="booking"></sdr-breadcrumbs>
            </div>
            <!-- <<< BreadCrumbs - Row -->

            <!-- >>> Content - Row -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:20px; color: red;">
                        <span class="index">
                            <i class="soap-icon-error circle"></i>
                        </span>
                        {{ pleaseselectoverview[getCurrentLocale] }}
                    </h1>
                </div>

                <div id="main" class="col-sm-8 col-md-9">
                    <div class="booking-information sdr-box" style="border: 1px solid red;">
                        <hr />
                        <div class="booking-confirmation clearfix">
                            <i class="soap-icon-notice icon circle"></i>
                            <div class="message">
                                <h4 class="main-message">{{ explanation[getCurrentLocale] }}</h4>
                                <p>{{ explanationsub[getCurrentLocale] }}</p>
                            </div>
                            <a href="https://fensterplatz.tickets" class="print-button button btn-small sundair">{{ goback[getCurrentLocale] }}</a>
                        </div>
                        <hr />
                        <br />
                        <h2>{{ solution[getCurrentLocale] }}</h2>
                        <p v-html="solutiontext[getCurrentLocale]"></p>
                        <br />
                        <hr />
                        <br />
                        <div style="display: flex; justify-content: space-between;">
                            <div>
                                <p class="red-color">{{ paymentmethod[getCurrentLocale] }}</p>
                                <br />
                                <a href="#" class="red-color underline view-link">https://mein-wunschplatz.de/</a>
                            </div>
                            <div style="display: flex; justify-content: end;">
                                <img src='/res/images/icon/warning.png' width='25%' />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Begin:Content-SideBar-Booking ------------------------- -->
                <div class="sidebar col-sm-4 col-md-3">
                    <sdr-contact-box></sdr-contact-box>
                </div>
                <!-- End:Content-SideBar-Booking --------------------------- -->
            </div>
            <!-- <<< Content - Row -->
        </div>
    </section>
</template>

<script>
    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import ContactBox from '../../shared/sidebar/ContactBox.vue';
    import { mapActions, mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-contact-box': ContactBox,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function () {

            return {
                pleaseselectoverview: {
                    en: 'Step 5: Something has gone wrong!',
                    de: 'Schritt 5: Etwas ist schief gelaufen!'
                },
                aborttitle: {
                    en: 'Something has gone wrong.',
                    de: 'Etwas ist schief gelaufen.',
                },
                explanation: {
                    en: 'Dear customer, we are sorry. Something went wrong.',
                    de: 'Sehr geehrter Kunde, es tut uns leid. Etwas ist schief gelaufen.',
                },
                explanationsub: {
                    en: 'You can see the next steps below.',
                    de: 'Die weitere Schritte sehen Sie unten.',
                },
                solution: {
                    en: 'What can i do?',
                    de: 'Was kann ich tun?',
                },
                goback: {
                    en: 'BACK TO THE HOMEPAGE',
                    de: 'ZURÜCK ZUR HOMEPAGE',
                },
                goback2: {
                    en: 'Back to: ',
                    de: 'Zurück zur: ',
                },
                paymentmethod: {
                    en: 'Your Payment method: Credit card',
                    de: 'Ihre Zahlungsmethode: Kreditkarte',
                },
                solutiontext: {
                    en: 'At the moment we cannot process your booking. Please check your payment information and try again. If the problem persists, please contact your bank. <br /><br />If you need further help or support, please feel free to contact our customer service department.',
                    de: 'Im Moment können wir Ihre Buchung nicht bearbeiten. Bitte überprüfen Sie Ihre Zahlungsinformationen und versuchen Sie es noch einmal. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an Ihre Bank.<br /><br />Wenn Sie weitere Hilfe oder Unterstützung benötigen, wenden Sie sich gerne an unseren Kundenservice.',
                },
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters(['getCurrentLocale']),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            let me = this;


            me.$toc('>>> components/checkout/abort/Abort.vue >>> created');
            if (this.$router.currentRoute.params.modulo !== undefined) {
                this.actn_call_releaseBooking(this.$router.currentRoute.params.modulo);
            }

        }, // eo function created()



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_releaseBooking',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
.booking-information>.booking-confirmation .main-message {
        color: red;
    }

    .travel-ideas .idea-title .index {
        background: red;
    }


    .booking-information>.booking-confirmation>.icon {
        color: red;
    }
</style>
